import { render, staticRenderFns } from "./InvoicesReferrers.vue?vue&type=template&id=1a31560b&"
import script from "./InvoicesReferrers.vue?vue&type=script&lang=js&"
export * from "./InvoicesReferrers.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesReferrers.vue?vue&type=style&index=0&id=1a31560b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports